<template>
  <div class="section-group">
    <SectionTitle>Assets</SectionTitle>
    <div class="section-group-data">
      <div class="section-group-title mb-1">Product Image</div>
      <div>
        <img
          v-if="serverUrl + selectedProduct.image"
          :src="getServerAssetUrl(selectedProduct.image)"
          style="width: 100px; max-width: 100%; margin-bottom: 15px;"
        />
        <input
          class="form-control form-control-sm"
          type="file"
          accept="image/*"
          @input="$emit('image-selected', $event.target.files[0])"
        />
        <Button @click="$emit('update')">
          <i class="fas fa-image"></i>
          {{ processing ? "Please wait..." : "Update Image" }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../UI/Button.vue"
import SectionTitle from "../UI/SectionTitle.vue"
import { getServerAssetUrl } from "../../utils/common"

export default {
  components: { Button, SectionTitle },
  props: {
    selectedProduct: {
      type: Object,
      required: true,
    },
    serverUrl: {
      type: String,
      default: "",
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getServerAssetUrl,
  },
}
</script>
